<template>
    <div>
        <join-header 
            :actIndex="actIndex" 
            :imgList="imgList" 
            :topStyle="topStyle" 
            :logo="logo"
            :productType="productType">
        </join-header>
        <transition name="jobshow" mode="out-in">
            <join-job @job="jobshow" v-if="jobId == -1" :jobList="jobContent"></join-job>
            <job-detail @back="jobs" v-else :jobInfo="jobContent[jobId]"></job-detail>
        </transition>
        <join-footer 
            :bottomNews="bottomNews"
            :bottom="bottom" 
            :bottomInfo="bottomInfo"
            :productType="productType">
        </join-footer>
    </div>
</template>

<script>
import JoinHeader from '@/components/pc/Header'
import JoinJob from '@/components/pc/JoinJob'
import JobDetail from '@/components/pc/JobDetail'
import JoinFooter from '@/components/pc/Footer'
export default {
    name: 'JoinUs',
    data () {
        return {
            screenStyle: {
                width: '',
                margin: "0 auto",
            },
            actIndex: 5,
            jobId: -1,
            topStyle: "",
            imgList: [],
            bottom: {},
            logo: '',
            bottomInfo: {},
            jobContent: [],
            productType: [],
            bottomNews: []
        }
    },
    components: {
        JoinHeader,
        JoinJob,
        JobDetail,
        JoinFooter,
    },
    mounted () {
        this.Pc_Mobile()
        this.getPageData()
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        Pc_Mobile () {
            if(this._isMobile()) {
                this.$router.replace('/m_joinus');
            }else{
                this.$router.replace('/joinus');
            }
        },
        getPageData () {
            this.$http.post('home/index/joinus',null, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background-image:url('"+this.$imgUrl+res.data.header[0].jrwm.replace(/\\/g,'/')+"')"
                this.bottomInfo = res.data.contact[0]
                this.jobContent = res.data.recruit
                this.productType = res.data.type
                this.bottomNews = res.data.b_news
                this.$nextTick(()=>{
                })
            })
        },
        jobshow (index) {
            this.jobId = index
        },
        jobs () {
            this.jobId = -1;
        }
    }
}
</script>

<style lang="stylus" scoped>
    .jobshow-enter,.jobshow-leave-to
        opacity: 0
    .jobshow-enter-active,.jobshow-leave-active
        transition: opacity .5s
</style>


// WEBPACK FOOTER //
// src/views/pc/JoinUs.vue